import React, { ReactNode } from 'react';

export enum DialogType {
  Alert = 'alert',
  Confirm = 'confirm',
  DeleteConfirm = 'deleteConfirm',
  Custom = 'custom',
  Notification = 'notification',
}

export interface ContentProps {
  onConfirm?: Function;
  onClose?: Function;
  entityType?: string;
}
export interface DialogPayload {
  id: string;
  type?: DialogType;
  header?: ReactNode;
  content: React.FunctionComponentElement<ContentProps>;
  data?: any;
  closeOnBackdropClick?: boolean;
  hideX?: boolean;
  closeCallBack?: Function;
}

export interface Overlays {
  dialogs: Array<DialogPayload>;
}
